// extracted by mini-css-extract-plugin
module.exports = {"head":"Product_head__2dqPe"};